/* global UProgramReferences */
class UProgram extends Uneet {
  constructor(domElement) {
    super(domElement)
    this.__init()
  }

  __init() {
    const referenceDOM = this._e.querySelector('.u_program-references')
    if (referenceDOM) {
      this.references = new UProgramReferences(referenceDOM)
    }
  }
}
